import { render, staticRenderFns } from "./MultipleChoiceCard.vue?vue&type=template&id=386e5fad&"
import script from "./MultipleChoiceCard.vue?vue&type=script&lang=ts&"
export * from "./MultipleChoiceCard.vue?vue&type=script&lang=ts&"
import style0 from "./MultipleChoiceCard.vue?vue&type=style&index=0&id=386e5fad&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports